<div class="d-flex justify-content-end mb-3">
  <button
    id="adminorcustomer_organizations_soarrules_socbulletins_addnew"
    type="button"
    class="cyflare-btn-primary"
    (click)="openEditor()"
  >
    Add new
  </button>
</div>

@if (datatableUrl(); as url) {
  <app-datatable
    [data-href]="url"
    [columns]="datatableColumns"
    [useOData]="true"
    (click)="onTableClick($event)"
  ></app-datatable>
}

@if (formGroup(); as form) {
  <kendo-dialog
    [title]="isNew() ? 'Add SOC Bulletin' : 'Edit SOC Bulletin'"
    [width]="520"
    [minWidth]="340"
    (close)="closeEditor()"
  >
    <form [formGroup]="form">
      <div class="mb-3">
        <label
          class="form-label small text-muted mb-1"
          for="adminorcustomer_organizations_soarrules_socbulletins_xdralerttype"
        >
          XDR Alert
        </label>
        <input
          id="adminorcustomer_organizations_soarrules_socbulletins_xdralerttype"
          class="form-control"
          formControlName="xdr_alert_type"
        />
      </div>

      <div class="mb-3">
        <label
          class="form-label small text-muted mb-1"
          for="adminorcustomer_organizations_soarrules_socbulletins_description"
        >
          Description
        </label>
        <input
          id="adminorcustomer_organizations_soarrules_socbulletins_description"
          class="form-control"
          formControlName="description"
        />
      </div>

      <div class="mb-3">
        <label
          class="form-label small text-muted mb-1"
          for="adminorcustomer_organizations_soarrules_socbulletins_requiredaction"
        >
          Required Action
        </label>
        <input
          id="adminorcustomer_organizations_soarrules_socbulletins_requiredaction"
          class="form-control"
          formControlName="required_action"
        />
      </div>

      <div class="mb-2">
        <label class="form-label small text-muted mb-1">Expiration Date</label>
        <kendo-datepicker formControlName="timebounds"></kendo-datepicker>
      </div>
    </form>

    <kendo-dialog-actions>
      <button
        id="adminorcustomer_organizations_soarrules_socbulletins_cancel"
        type="button"
        class="cyflare-btn-secondary cyflare-btn-sm"
        [disabled]="isSaving()"
        (click)="closeEditor()"
      >
        Cancel
      </button>
      <button
        [id]="
          isNew()
            ? 'adminorcustomer_organizations_soarrules_socbulletins_add'
            : 'adminorcustomer_organizations_soarrules_socbulletins_update'
        "
        type="button"
        class="cyflare-btn-primary cyflare-btn-sm"
        [disabled]="isSaving()"
        (click)="save()"
      >
        @if (isSaving()) {
          <span
            class="spinner-border spinner-border-sm me-1"
            role="status"
          ></span>
          Saving...
        } @else {
          {{ isNew() ? 'Add' : 'Update' }}
        }
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
}
